export default "__VITE_ASSET__048edd84__"